<template>
<section>
  <div class="card shadow-sm form-card mb-4">
    <div class="form-card-header">
      <div class="section-icon">
        <i class="fe fe-tag" style="font-size: 13px;"></i>
      </div>
      <h6 class="mb-0 font-weight-bold text-white">Add Service Category</h6>
    </div>
    <div class="card-body px-4 py-4">
      <div class="form-row">
        <div class="form-group col-md-8">
          <label class="small font-weight-bold text-secondary">Category Name <span class="text-danger">*</span></label>
          <input type="text" required class="form-control" placeholder="e.g. Radiology" v-model="register.category_name">
        </div>
        <div class="form-group col-md-4">
          <label class="small font-weight-bold text-secondary">Laboratory Test?</label>
          <select class="form-control" v-model="register.is_laboratory_test">
            <option :value="option_true">Yes</option>
            <option :value="option_false" selected>No</option>
          </select>
        </div>
      </div>
      <button @click="registerCat" class="btn btn-submit">
        <i class="fe fe-plus mr-1"></i> Add Category
      </button>
    </div>
  </div>

  <div class="card shadow-sm table-card">
    <div class="d-flex align-items-center px-4 pt-4 pb-3">
      <i class="fe fe-list text-primary mr-2"></i>
      <h6 class="mb-0 font-weight-bold">Existing Categories</h6>
      <span v-if="Array.isArray(categories)" class="badge badge-soft-info ml-2">{{ categories.length }}</span>
    </div>
    <div class="px-4 pb-4">
      <ul class="category-list" v-if="Array.isArray(categories) && categories.length">
        <li v-for="cat in categories" :key="cat.id" class="category-item d-flex align-items-center justify-content-between">
          <div>
            <span class="category-name">{{ cat.category_name }}</span>
            <span v-if="cat.is_laboratory_test" class="badge badge-soft-info ml-2" style="font-size: 0.7rem;">Lab</span>
          </div>
          <button @click="deleteCat(cat)" class="btn btn-sm btn-outline-danger">
            <i class="fe fe-trash-2"></i>
          </button>
        </li>
      </ul>
      <div v-else class="text-center text-muted py-4">
        <i class="fe fe-inbox" style="font-size: 2rem; opacity: 0.3;"></i>
        <p class="mt-2 mb-0 small">No categories yet</p>
      </div>
    </div>
  </div>

  <div class="vld-parent">
    <loading :active.sync="isLoading"
    loader="dots"
    :can-cancel="true"
    :is-full-page="fullPage"></loading>
  </div>
</section>
</template>

<script>
  // Import component
     import Loading from 'vue-loading-overlay';
     // Import stylesheet
     import 'vue-loading-overlay/dist/vue-loading.css';
     // Init plugin


export default {
  components: {
      Loading
  },
  data(){
    return{
      user:null,
      option_true:true,
      option_false:false,
      edit:false,
      show:false,
      isLoading: false,
      fullPage: true,
      categories:"",
      register:{
                category_name:"",
                is_laboratory_test:"",
            }
    }
  },
  beforeMount(){
    this.user = JSON.parse(localStorage.getItem('user'))
    this.axios.get(`/api/v1/auth/service_category`)
                .then(response => {
                    this.categories = response.data.data
                    console.log(response)
                })
                .catch(error => {
                    console.error(error);
                })
  },
  methods:{
    deleteCat(cat){
      if (confirm('Are you sure you want to delete Category?') ) {
        this.axios.delete(`/api/v1/auth/service_category/${cat.id}`)
                    .then(response => {
                        console.log(response)
                        this.getCategories()
                        this.$toasted.success('Deleted Successfully!', {position: 'top-left', duration:5000 })

                    })
                    .catch(error => {
                        console.error(error);
                    })
      }

    },

    getCategories(){
      this.axios.get(`/api/v1/auth/service_category`)
                  .then(response => {
                      this.categories = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },

    registerCat(){
        this.isLoading = true;
        this.axios.post('/api/v1/auth/service_category',{
          category_name : this.register.category_name,
          is_laboratory_test : this.register.is_laboratory_test,
          // agency_id : this.user.id
        })
        .then(response=>{

            console.log(response);
            this.isLoading = false;
            this.$toasted.success('Added!', {position: 'top-left', duration:5000 })
            this.getCategories()
            this.$emit('getCategories')
            this.clearIt()

        })
        .catch(error=>{
            console.log(error.response)
            this.isLoading = false;
            this.$toasted.error('Not added', {position: 'top-left', duration:5000 })

        })
    },

    clearIt(){
      this.register.category_name = "";
      this.register.is_laboratory_test = "";
    },

  },
  created(){
//
  }

}
</script>

<style scoped>
.form-card, .table-card {
  border-radius: 12px;
  border: 1px solid #e9ecef;
  overflow: hidden;
}
.form-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
}
.section-icon {
  width: 28px;
  height: 28px;
  background: rgba(255,255,255,0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
}
.category-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.category-item {
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
}
.category-item:last-child { border-bottom: none; }
.category-name { font-weight: 500; font-size: 0.9rem; }
.btn-submit {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border: none;
  color: #fff;
  border-radius: 8px;
  font-weight: 600;
  padding: 8px 24px;
}
.btn-submit:hover { opacity: 0.9; color: #fff; }
.form-control:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 0.15rem rgba(37,99,235,0.15);
}
</style>
